import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import '../../entity-forms.css';

const CITIES = ['Dubai','Abu Dhabi','Sharjah','Ajman','Ras Al Khaimah','Fujairah','Umm Al Quwain'];

export default function Team() {
  const API_URL = process.env.REACT_APP_API_URL;

  const [data, setdata]             = useState([]);
  const [isload, setisload]         = useState(true);
  const [search, setSearch]         = useState('');

  const initForm = { createdBy: sessionStorage.getItem('userid'), status: 'active' };
  const [form, setForm]             = useState(initForm);
  const [isEdit, setIsEdit]         = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [msg, setMsg]               = useState('');
  const [errMsg, setErrMsg]         = useState('');

  useEffect(() => { loadList(); }, []);

  const loadList = async () => {
    setisload(true);
    try {
      const res = await axios.get(`${API_URL}shypvdriverapp/team/getTeams`);
      if (res.data.data) setdata(res.data.data);
    } catch {}
    setisload(false);
  };

  const openAdd  = () => { setForm(initForm); setIsEdit(false); setMsg(''); setErrMsg(''); setDrawerOpen(true); };
  const openEdit = (row) => { setForm({ ...row }); setIsEdit(true); setMsg(''); setErrMsg(''); setDrawerOpen(true); };
  const closeDrawer = () => { setDrawerOpen(false); setForm(initForm); };

  const handleSubmit = async () => {
    if (!form.teamName || !form.shortCode || !form.city) { setMsg('Please fill all required fields (*)'); return; }
    setMsg('');
    try {
      const url = isEdit
        ? `${API_URL}shypvdriverapp/team/updateTeam`
        : `${API_URL}shypvdriverapp/team/createTeam`;
      const payload = { teamName: form.teamName, shortCode: form.shortCode, city: form.city, status: form.status || 'active', createdBy: form.createdBy };
      if (isEdit) payload.teamId = form.teamId;
      const res = await axios.post(url, payload);
      if (res.data.success) { closeDrawer(); loadList(); }
      else setMsg('Operation failed. Please try again.');
    } catch (e) { setErrMsg('Server error: ' + (e.response?.data?.message || e.message)); }
  };

  const handleDelete = async () => {
    if (!selectedIds.length) return;
    if (!window.confirm(`Delete ${selectedIds.length} team(s)?`)) return;
    try {
      for (const id of selectedIds) {
        await axios.delete(`${API_URL}shypvdriverapp/team/deleteTeam`, {
          headers: { 'Content-Type': 'application/json' },
          data: { teamId: id },
        });
      }
      setSelectedIds([]); loadList();
    } catch { setErrMsg('Error deleting team'); }
  };

  const toggleSelect = (id, row) => {
    setSelectedIds(prev => {
      if (prev.includes(id)) { const next = prev.filter(x => x !== id); if (!next.length) setForm(initForm); return next; }
      setForm(row); return [...prev, id];
    });
  };

  const filtered = data.filter(r =>
    !search || r.teamName?.toLowerCase().includes(search.toLowerCase()) ||
    r.shortCode?.toLowerCase().includes(search.toLowerCase())
  );

  const role = sessionStorage.getItem('role');
  const canDelete = role === 'super_admin' || role === 'admin';

  return (
    <div style={{ fontFamily:"'Poppins', sans-serif" }}>
      <div className="em-action-bar">
        <div className="em-search-wrap">
          <i className="fa fa-search" />
          <input className="em-search" placeholder="Search teams…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <button className="em-btn em-btn-primary" onClick={openAdd}><i className="fa fa-plus" /> Add Team</button>
        {selectedIds.length === 1 && (
          <button className="em-btn em-btn-warning" onClick={() => openEdit(form)}><i className="fa fa-pencil" /> Edit</button>
        )}
        {selectedIds.length > 0 && canDelete && (
          <button className="em-btn em-btn-danger" onClick={handleDelete}><i className="fa fa-trash" /> Delete ({selectedIds.length})</button>
        )}
        <CSVLink data={filtered} filename="teams.csv" className="em-btn em-btn-csv"><i className="fa fa-download" /> Export</CSVLink>
        {errMsg && <span className="em-msg-error">{errMsg}</span>}
      </div>

      <div style={{ overflowX:'auto' }}>
        <table className="em-table">
          <thead>
            <tr>
              <th className="em-col-h" style={{ width:36 }}>
                <input type="checkbox" onChange={e => setSelectedIds(e.target.checked ? filtered.map(r => r.teamId) : [])}
                  checked={selectedIds.length > 0 && selectedIds.length === filtered.length} />
              </th>
              {['ID','Team Name','Short Code','City','Status','Actions'].map(h => <th key={h} className="em-col-h">{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {isload ? (
              <tr><td colSpan={7} style={{ textAlign:'center', padding:40, color:'#94a3b8' }}>
                <i className="fa fa-spinner fa-spin" style={{ fontSize:22, display:'block', marginBottom:8 }} />Loading teams…
              </td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={7} style={{ textAlign:'center', padding:40, color:'#94a3b8' }}>No teams found</td></tr>
            ) : filtered.map((row, i) => {
              const sel = selectedIds.includes(row.teamId);
              return (
                <tr key={row.teamId} className={`em-tr${sel?' selected':''}`}
                  style={{ animation:`emFadeUp 0.3s ${Math.min(i,20)*0.018}s ease-out both` }}>
                  <td className="em-td"><input type="checkbox" checked={sel} onChange={() => toggleSelect(row.teamId, row)} /></td>
                  <td className="em-td" style={{ color:'#64748b', fontSize:12 }}>{row.teamId}</td>
                  <td className="em-td" style={{ fontWeight:600 }}>{row.teamName}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.shortCode}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.city}</td>
                  <td className="em-td">
                    <span className={`em-badge ${row.status==='active'?'em-badge-green':'em-badge-grey'}`}>{row.status}</span>
                  </td>
                  <td className="em-td">
                    <button className="em-btn em-btn-ghost" style={{ padding:'5px 10px', fontSize:11 }} onClick={() => openEdit(row)}>
                      <i className="fa fa-pencil" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div style={{ padding:'10px 16px', background:'#f8fafc', borderTop:'1px solid #e8edf2', fontSize:12, color:'#94a3b8', fontWeight:600 }}>
        {filtered.length} team{filtered.length!==1?'s':''}
      </div>

      {drawerOpen && (
        <>
          <div className="em-overlay" onClick={closeDrawer} />
          <div className="em-drawer">
            <div className="em-drawer-header">
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <div style={{ width:36, height:36, borderRadius:11, background:'rgba(255,255,255,0.12)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <i className="fa fa-users" style={{ color:'#fff', fontSize:16 }} />
                  </div>
                  <div>
                    <p className="em-drawer-title">{isEdit ? 'Edit Team' : 'Add New Team'}</p>
                    <p className="em-drawer-sub">{isEdit ? `ID: ${form.teamId}` : 'Fill in the team details below'}</p>
                  </div>
                </div>
                <button onClick={closeDrawer} style={{ background:'rgba(255,255,255,0.1)', border:'none', borderRadius:10, width:30, height:30, cursor:'pointer', color:'#fff', fontSize:18, display:'flex', alignItems:'center', justifyContent:'center' }}>×</button>
              </div>
            </div>
            <div className="em-drawer-body">
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Team Name<span className="em-req">*</span></label>
                  <input className="em-field" value={form.teamName||''} placeholder="e.g. Dubai Central"
                    onChange={e => setForm(p => ({ ...p, teamName: e.target.value }))} />
                </div>
                <div className="em-form-row">
                  <label className="em-label">Short Code<span className="em-req">*</span></label>
                  <input className="em-field" value={form.shortCode||''} placeholder="e.g. DXB"
                    onChange={e => setForm(p => ({ ...p, shortCode: e.target.value }))} />
                </div>
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">City<span className="em-req">*</span></label>
                  <select className="em-field" value={form.city||''} onChange={e => setForm(p => ({ ...p, city: e.target.value }))}>
                    <option value="">— Select city —</option>
                    {CITIES.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div className="em-form-row">
                  <label className="em-label">Status</label>
                  <select className="em-field" value={form.status||'active'} onChange={e => setForm(p => ({ ...p, status: e.target.value }))}>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
              </div>
              {msg    && <p className="em-msg-error">{msg}</p>}
              {errMsg && <p className="em-msg-error">{errMsg}</p>}
            </div>
            <div className="em-drawer-footer">
              <button className="em-dismiss-btn" onClick={closeDrawer}>Cancel</button>
              <button className="em-save-btn" onClick={handleSubmit}>
                <i className="fa fa-check" style={{ marginRight:6 }} />{isEdit?'Update Team':'Save Team'}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
